module.exports = __webpack_public_path__ + "img/signatureEle.f33e5caa.svg";